import createError from 'err-code';
import { get } from 'lodash';

const getApiErrorMessage = (err: unknown, message = 'API error') => get(err, 'response.data.errors[0].title', message);

export const createApiError = (err: unknown, message = 'API error') =>
  createError(err, 'ApiError', { message: getApiErrorMessage(err, message) });
